import { Component } from '@angular/core';

@Component({
  selector: 'ngx-shared',
  template: `
    <router-outlet></router-outlet>
  `,
})
export class PublicSharedComponent {}
